import React from "react";
import PropTypes from 'prop-types'

const workExpItem = ({ job }) => {
  const { designation, duration, companyName, responsibilities, skills } = job;
  return job ? (
    <div className="card w-75">
      <div className="card-body">
        <div className="d-flex">
          <h4 className="card-title">
            <strong>{designation}</strong>
          </h4>
          <span className="ml-auto">{duration}</span>
        </div>
        {/* <p className="mb-0">{companyName}</p> */}
        <div className="work-responsibility">
          <ul>
            {responsibilities.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
          <h6>Skills: {skills}</h6>
        </div>
      </div>
    </div>
  ) : null;
};

workExpItem.propTypes = {
  job: PropTypes.object.isRequired,
}

export default workExpItem;
